import { render, staticRenderFns } from "./MigrateEmail.vue?vue&type=template&id=051dda70"
import script from "./MigrateEmail.vue?vue&type=script&lang=js"
export * from "./MigrateEmail.vue?vue&type=script&lang=js"
import style0 from "./MigrateEmail.vue?vue&type=style&index=0&id=051dda70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports